<template lang="pug">
div(v-if="hasPaymentwallDetails" class="mb-4")
  h3.text-sm.font-semibold.mb-3 Paymentwall Details
  //- Currency conversion info
  div(v-if="pmwData.CURRENCY_CODE && data.extra?.currency && pmwData.CURRENCY_CODE !== data.extra.currency" class="mb-3 p-3 bg-blue-50 dark:bg-blue-950/30 rounded-lg")
    p.text-sm.font-medium
      | Converted: {{ formatCurrency(data.total_fee, data.extra.currency) }} → {{ formatCurrency(Number(pmwData.REVENUE_PAYMENT_LOCAL), pmwData.CURRENCY_CODE) }}
    p.text-xs.text-muted-foreground.mt-1
      | Net after fees: {{ formatCurrency(Number(pmwData.REVENUE_LOCAL), pmwData.CURRENCY_CODE) }}
  .grid.grid-cols-2.gap-4
    div(v-if="data.extra?.actual_payment_method")
      p.text-xs.text-muted-foreground.mb-1 Payment Method
      p.text-sm {{ paymentwallMethodName }}
    div(v-if="pmwData.USER_IP")
      p.text-xs.text-muted-foreground.mb-1 User IP
      IPWithGeo(:ip="pmwData.USER_IP" class="text-sm")
    div(v-if="pmwData.COUNTRY_CODE")
      p.text-xs.text-muted-foreground.mb-1 Country
      p.text-sm {{ pmwData.COUNTRY_CODE }}
    div(v-if="data.pmw_ref")
      p.text-xs.text-muted-foreground.mb-1 Reference
      a(:href="`https://api.paymentwall.com/developers/reports/transaction-details?ref_id=${data.pmw_ref}`" target="_blank" class="text-sm text-blue-600 hover:underline inline-flex items-center gap-1")
        | {{ data.pmw_ref }}
        Icon(name="lucide:external-link" class="w-3 h-3")
    div(v-if="notificationDetails.PAYMENT_TYPE")
      p.text-xs.text-muted-foreground.mb-1 Payment Type
      p.text-sm {{ notificationDetails.PAYMENT_TYPE }}
    div(v-if="notificationDetails.PAYMENT_DATETIME")
      p.text-xs.text-muted-foreground.mb-1 Payment Time
      p.text-sm {{ notificationDetails.PAYMENT_DATETIME }}
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import IPWithGeo from '@/components/IPWithGeo.vue'

const props = defineProps<{
  data: any
}>()

const notificationDetails = computed(() => props.data?.extra?.notification_details || {})
const pmwData = computed(() => props.data?.extra?.pmw || {})

const hasPaymentwallDetails = computed(() => 
  props.data?.channel === 'Paymentwall' && 
  (Object.keys(notificationDetails.value).length > 0 || Object.keys(pmwData.value).length > 0)
)

// Paymentwall payment method display name
const paymentwallMethodName = computed(() => {
  const method = props.data?.extra?.actual_payment_method
  if (!method) return 'Card'
  const methodMap: Record<string, string> = {
    'unionpay': 'UnionPay',
    'cc': 'Credit Card',
    'alipay': 'Alipay',
    'wechat': 'WeChat Pay'
  }
  return methodMap[method] || method
})

function formatCurrency(amount: number, currency: string) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency
  }).format(amount)
}
</script>